import { ArrowDownTrayIcon, CheckIcon } from "@heroicons/react/20/solid";
import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
} from "@material-tailwind/react";
import {
  Square3Stack3DIcon,
  UserCircleIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/solid";
import React from "react";
import PensionAnnuityTabs from "../InvestComps/PensionAnnuityTabs";

export default function EquityFund() {
  return (
    <div className="text-ternary-dark dark:text-ternary-light  ">
      <div className="mx-auto max-w-7xl px-6 pb-10 lg:px-8">
        <div className="mx-auto mt-16 max-w-xl rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-4xl font-bold tracking-tight">Pension Annuity</h3>
            <p className="mt-6 text-base max-w-lg leading-7 ">
            An annuity is an insurance policy that gives you a guaranteed income for the rest of your life or for a fixed amount of time. You can use your pension fund to buy an annuity that will provides you with a regular income after retirement.
            </p>
            <p className="mt-6  text-base max-w-lg leading-7 ">
            The annuity can be taken individually or jointly with a spouse. If the annuity is shared with a spouse, it reverts to the surviving spouse in case one dies before retirement age. It is paid on a regular basis according to your preference whether monthly, quarterly, semi-annually or annually for life.
            </p>

            <div className="mt-10 flex items-center gap-x-4">
              <a
                href="#"
                className="mt-10 block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Application Form
              </a>
            </div>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-xl pt-24 lg:flex-shrink-0">
            <PensionAnnuityTabs />
          </div>
        </div>
      </div>
    </div>
  );
}
